<template>
	<b-card no-body>
		<b-card-header class="border-0">
			<h3 class="mb-0">ESTADO DE AVALUOS</h3>
		</b-card-header>
		<el-scrollbar>
			<el-table
				style="width: 100%"
				:data="projects"
			>
				<el-table-column
					label="Períto"
					prop="title"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="# Asignación"
					prop="budget"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Tipo"
					prop="type"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Ciudad"
					prop="city"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Valor de Realización"
					prop="vrealizacion"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Valor de Mercado"
					prop="vmercado"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Ubicacion"
					prop="locationmap"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Oficial de Cuenta"
					prop="oaccount"
					min-width="200px"
				>
				</el-table-column>

				<el-table-column
					label="Estado"
					min-width="200px"
					prop="status"
				>
					<template v-slot="{ row }">
						<badge
							class="badge-dot mr-4"
							type=""
						>
							<i :class="`bg-${row.statusType}`"></i>
							<span
								class="status"
								:class="`text-${row.statusType}`"
							>{{
                row.status
              }}</span>
						</badge>
					</template>
				</el-table-column>
				<el-table-column
					label="Valor a Facturar"
					prop="vfactura"
					min-width="200px"
				>
				</el-table-column>
				<el-table-column
					label="Informe"
					lo
					min-width="150px"
				>
					<template v-slot="{ row }">
						<button
							v-if="row.status == 'completed'"
							v-on:click="goto(row.link)"
						>
							PDF
						</button>
					</template>
				</el-table-column>
			</el-table>
			<b-card-footer class="py-4 d-flex justify-content-end">
				<base-pagination
					v-model="currentPage"
					:per-page="5"
					:total="50"
				></base-pagination>
			</b-card-footer>
		</el-scrollbar>
	</b-card>
</template>
<script>
import projects from "./../projects";
import { Table, TableColumn } from "element-ui";
export default {
	name: "light-table",
	components: {
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			projects,
			currentPage: 1
		};
	},
	methods: {
		goto: function (link) {
			window.open(link);
		}
	}
};
</script>

<style scoped>
	@import url("//unpkg.com/element-ui@2.15.3/lib/theme-chalk/index.css");
</style